import { useLocation } from "react-router-dom";
import { useMaintenanceMode } from "@/hooks/useMaintenanceMode";
import { useUserRoles } from "@/hooks/useUserRoles";
import MaintenanceScreen from "./MaintenanceScreen";

/**
 * Bloqueia a plataforma com o ecrã de manutenção BeraStays quando:
 * - o super admin ativa o modo manutenção, ou
 * - o backend está indisponível (serviços pausados).
 * Admins e rotas /admin continuam acessíveis.
 */
export function MaintenanceGate() {
  const { active, reason, expectedDate, ceoName, message, checking, retry } = useMaintenanceMode();
  const { isAdmin, isSuperAdmin } = useUserRoles();
  const location = useLocation();

  const isAdminRoute = location.pathname.startsWith("/admin");
  if (!active || isAdmin || isSuperAdmin || isAdminRoute) return null;

  return (
    <MaintenanceScreen
      reason={reason}
      expectedDate={expectedDate}
      ceoName={ceoName}
      message={message}
      checking={checking}
      onRetry={retry}
    />
  );
}

export default MaintenanceGate;
